import { DictionaryKeyList, RuntimeDictionaryFields, stringifyDocument, toDictionaryRows } from "./dictionaryRows.js";
import { resetPreLockView } from "./v3/parser/settings.js";
import { parser as parser$1 } from "./v3/parser/index.js";
import { parser as parser$2 } from "./v2/parser/index.js";
import { v2ToV3 } from "./convert/v2ToV3.js";
import { normalizeSettings } from "./normalizeSettings.js";
import { mapValues, omit, pick } from "es-toolkit";
//#region ../erd-editor-schema/dist/parser.js
function parser(source) {
	const json = JSON.parse(source);
	if (Reflect.get(json, "version") === "3.0.0") return parser$1(json);
	const schema = v2ToV3(parser$2(json));
	resetPreLockView(schema.settings);
	return schema;
}
function toJson(schemaV3) {
	const source = pick(schemaV3, [
		"$schema",
		"version",
		"settings",
		"doc",
		"collections"
	]);
	return stringifyDocument({
		...source,
		settings: normalizeSettings(source.settings),
		...withoutEmptyFields(source)
	});
}
var TABLE_DEFAULTS = {
	logicalName: "",
	groupId: "",
	nameDerived: false
};
var COLUMN_DEFAULTS = {
	logicalName: "",
	domainId: ""
};
var DICTIONARY_IDS = {
	wordEntities: "wordIds",
	termEntities: "termIds",
	domainEntities: "domainIds"
};
function withoutDefaults(entity, defaults) {
	const left = Object.keys(defaults).filter((key) => Reflect.get(entity, key) === defaults[key]);
	return left.length ? omit(entity, left) : entity;
}
function withoutEmptyFields({ doc, collections }) {
	const hasGroups = (doc.tableGroupIds?.length ?? 0) !== 0 || Object.keys(collections.tableGroupEntities ?? {}).length !== 0;
	const written = {
		doc: hasGroups ? { ...doc } : omit(doc, ["tableGroupIds"]),
		collections: {
			...hasGroups ? collections : omit(collections, ["tableGroupEntities"]),
			tableEntities: mapValues(collections.tableEntities ?? {}, (table) => withoutDefaults(table, TABLE_DEFAULTS))
		}
	};
	if (collections.tableColumnEntities) written.collections.tableColumnEntities = mapValues(collections.tableColumnEntities, (column) => withoutDefaults(column, COLUMN_DEFAULTS));
	for (const key of DictionaryKeyList) {
		const idsKey = DICTIONARY_IDS[key];
		const ids = doc[idsKey] ?? [];
		const entities = Object.values(collections[key] ?? {});
		if (ids.length === 0 && entities.length === 0) {
			delete written.doc[idsKey];
			delete written.collections[key];
		} else {
			written.doc[idsKey] = ids;
			written.collections[key] = toDictionaryRows(key, entities, RuntimeDictionaryFields[key]);
		}
	}
	return written;
}
//#endregion
export { parser, toJson };
